import moment from "moment-timezone";
import "moment/locale/es";

/**
 * Obtener la fecha actual según la zona horaria
 * @returns  @returns {Object} - Fecha en formato objeto
 */
export function getTimeStorageTimezone() {
  var dateMomentEnd = moment()
    .tz(sessionStorage.getItem("tz"))
    .format("MM/DD/YYYY h:mm:ss a");
  var dateJsonEnd = new Date(dateMomentEnd);
  let yearEnd = dateJsonEnd.getFullYear();
  let monthEnd = dateJsonEnd.getMonth();
  let dayEnd = dateJsonEnd.getDate();
  let hoursEnd = dateJsonEnd.getHours();
  let minutesEnd = dateJsonEnd.getMinutes();
  let secondsEnd = dateJsonEnd.getSeconds();

  return { yearEnd, monthEnd, dayEnd, hoursEnd, minutesEnd, secondsEnd };
}

/**
 * 
 * @param {number} time - Tiempo que se restará expresado en números
 * @param {string} type - Unidad de tiempo - Dias, Horas, Minutos, Segundos, etc. 
 * @returns {Object} - Fecha en formato objeto
 */
export function substractTimeToStorageTimeZone(time, type) {
  const dateMoment = moment()
    .tz(sessionStorage.getItem("tz"))
    .subtract(time, type)
    .format("MM/DD/YYYY h:mm:ss a");
  const dateJson = new Date(dateMoment);
  const year = dateJson.getFullYear();
  const month = dateJson.getMonth();
  const day = dateJson.getDate();
  const hours = dateJson.getHours();
  const minutes = dateJson.getMinutes();
  const seconds = dateJson.getSeconds();

  return { year, month, day, hours, minutes, seconds };
}
